'use strict';

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import iziToast from "izitoast";

const input = document.querySelector("#datetime-picker");
const button = document.querySelector("button");
let userSelectedDate = null;
let interval = null;

button.disabled = true;

const options = {
  enableTime: true,
  time_24hr: true,
  defaultDate: new Date(),
  minuteIncrement: 1,
    onClose(selectedDates) {
        let selectedDate = selectedDates[0];
        const now = new Date();
        
        if (selectedDate <= now) {
            userSelectedDate = null;
            button.disabled = true;
            iziToast.error({
                position: 'topCenter',
                message: 'Please choose a date in the future',
            });
        } else {
            userSelectedDate = selectedDate;
            button.disabled = false;
        }
  },
};

flatpickr(input, options);

const daysCount = document.querySelector("[data-days]");
const hoursCount = document.querySelector("[data-hours]");
const minutesCount = document.querySelector("[data-minutes]");
const secondsCount = document.querySelector("[data-seconds]");

function convertMs(ms) {
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  const days = Math.floor(ms / day);
  const hours = Math.floor((ms % day) / hour);
  const minutes = Math.floor(((ms % day) % hour) / minute);
  const seconds = Math.floor((((ms % day) % hour) % minute) / second);

  return { days, hours, minutes, seconds }
};

function addLeadingZero(value) {
    return String(value).padStart(2, '0')
};

function setTimer() {
    const now = new Date();
    const difference = userSelectedDate - now;

    if (difference <= 0) {
        clearInterval(interval);
        button.disabled = false;
        input.disabled = false;
        return;
    }

    const time = convertMs(difference);
    daysCount.textContent = addLeadingZero(time.days);
    hoursCount.textContent = addLeadingZero(time.hours);
    minutesCount.textContent = addLeadingZero(time.minutes);
    secondsCount.textContent = addLeadingZero(time.seconds);
};

button.addEventListener('click', () => {
    button.disabled = true;
    input.disabled = true;

    if (!userSelectedDate) return;
    if (interval) {
        clearInterval(interval);
    };

    setTimer();
    interval = setInterval(setTimer, 1000);
});

